<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <validation-observer ref="createObserver" slim>
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.categories.categoryImage') + ' EN'">
                <b-form-file v-model="createForm.image_en" accept="image/*"></b-form-file>
              </b-form-group>
              <b-form-group :label="$t('pages.categories.categoryImage') + ' RU'">
                <b-form-file v-model="createForm.image_ru" accept="image/*"></b-form-file>
              </b-form-group>

              <b-text-input-with-validation
                v-model="createForm.link"
                name="link"
                :label="$t('menu.links') + ' ' + $t('anyform.forSite')"
                :disabled="isLoading"
                rules="required"
              ></b-text-input-with-validation>

              <b-form-group :label="$t('pages.manufacturers.chooseCategory') + ' ' + $t('anyform.forApp')">
                <v-select
                  v-model="createForm.categoryId"
                  :options="requirements"
                  :reduce="(req) => req.id"
                  label="name"
                />
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="createForm.active">{{ $t('anyform.showInTheSite') }}</b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="createForm.mobile">{{ $t('anyform.showInTheApp') }}</b-form-checkbox>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                :disabled="isLoading"
                :class="{
                  'btn-multiple-state mt-2': true,
                  'show-spinner': isLoading
                }"
              >
                <span class="spinner d-inline-block">
                  <span class="bounce1"></span>
                  <span class="bounce2"></span>
                  <span class="bounce3"></span>
                </span>
                <span class="label">
                  {{ $t('buttons.save') }}
                </span>
              </b-button>
            </b-form>
          </validation-observer>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import { handleArrayDataInternalization } from '@/utils'
import BTextInputWithValidation from '@/components/Form/BTextInputWithValidation.vue'
export default {
  components: { BTextInputWithValidation },
  data: () => ({
    isLoading: false,
    createForm: {
      link: '',
      image_en: null,
      image_ru: null,
      active: false,
      categoryId: null,
      mobile: false
    }
  }),
  computed: {
    requirements() {
      const requirements = this.$store.getters['manufacturers/requirements']
      return handleArrayDataInternalization(requirements, ['name'], this.$i18n.locale)
    }
  },
  mounted() {
    this.fetchRequirements()
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    fetchRequirements() {
      this.$store.dispatch('manufacturers/fetchRequirements')
    },
    async onSubmit() {
      const success = await this.$refs.createObserver.validate()
      if (success) {
        const payload = {
          link: this.createForm.link,
          image_en: this.createForm.image_en || '',
          image_ru: this.createForm.image_ru || '',
          active: this.createForm.active ? '1' : '0',
          category_id: this.createForm.categoryId || null,
          mobile: this.createForm.mobile ? '1' : '0'
        }
        this.$store.dispatch('links/createLink', { payload, vm: this })
      }
    }
  }
}
</script>
